//Note that these plancodes match the ProdIDs from the interfaceSetup
export const ProdID = {
  TERM10: '0897',
  TERM20: '0898',
  TERM30: '0899',
  TERM100JOINT: '0562',
  TERM100: '0564',
  WHOLELIFE: '0903',
  WHOLELIFE20PAY: '0904',
  UL: '0602',
};

export const DivOptions = {
  RAP: 'RAP',
  PUA: 'PUA',
  DOD: 'DOD',
  NONE: 'NONE',
};

export const PolicyTypes = {
  SINGLE: 'SINGLE',
  JOINTFIRST: 'JOINTFIRST',
  JOINTLAST: 'JOINTLAST',
};

export const interfaceItemsPolicyTypes = {
  TERM100: 'TERM100',
  LEVELTERM: 'LEVELTERM',
  WHOLELIFE: 'WHOLELIFE',
  UL: 'UL',
};

//term 10, term 20 or term 30
export const isTermPolicy = (prodId) => {
  return prodId === ProdID.TERM10 || prodId === ProdID.TERM20 || prodId === ProdID.TERM30;
};

//term 100
export const isTerm100Policy = (prodId) => {
  return prodId === ProdID.TERM100;
};

//whole life policy
export const isWholeLifePolicy = (prodId) => {
  return prodId === ProdID.WHOLELIFE || prodId === ProdID.WHOLELIFE20PAY;
};

//universal life policy
export const isUniversalLifePolicy = (prodId) => {
  return prodId === ProdID.UL;
};
